import { put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { SyncHistoryService } from './sync-history.service';
import { syncHistoryActions } from './sync-history.slice';
import { SyncLogRequest } from '../models/sync-history.model';

const fetchSyncLogsList = function* ({ payload }: PayloadAction<SyncLogRequest>) {
    const { hasErrors, errors, value } = yield SyncHistoryService.fetchSyncLogsList(payload);
    if (hasErrors && errors) {
        const error: string = errors[0];
        yield put({
            type: syncHistoryActions.fetchSyncLogsFailed.type,
            payload: error
        });
    } else {
        yield put({
            type: syncHistoryActions.fetchSyncLogsSuccess.type,
            payload: value
        });
    }
};

const fetchSyncLogsListWatch = function* () {
    yield takeLatest(syncHistoryActions.fetchSyncLogs.type, fetchSyncLogsList);
};

export { fetchSyncLogsListWatch };
